import { Typography } from '@/components/common';
import clsx from 'clsx';

interface Props {
	message: string;
	role: string; //'system' | 'user' | 'options';
	time: string;
}

export const ChatMessage: React.FC<Props> = ({ message, role }) => {
	return (
		<div
			className={clsx('flex flex-col', {
				'justify-end items-end': role === 'user' || role === 'options',
			})}
		>
			<div
				className={clsx('p-3 rounded-2xl w-fit', {
					'rounded-tl-none bg-green-20': role === 'system',
					'rounded-tr-none bg-purple-35': role === 'user',
					'rounded-tr-none border border-purple-150 cursor-pointer':
						role === 'options',
				})}
			>
				<Typography
					type="regular-14"
					className={clsx({
						'text-purple-150': role === 'options',
					})}
				>
					{message}
				</Typography>
			</div>
		</div>
	);
};

// ------------- Messages styles to Backend -----------------//
{
	/* --------- Cases message ----------------- */
}
{
	/* <>
<span className="p-3 rounded-2xl w-fit rounded-tl-none bg-green-20">
	<p className="text-black font-normal text-sm xl:text-sm">
		Which case would you like to inquire about?{' '}
	</p>
</span>

<div className="flex flex-col justify-end items-end gap-3">
	<button
		data-type="case-question"
		data-id="9981710b-7f38-46f3-8d50-0f072d1fa450"
		className="bg-white p-3 rounded-2xl w-fit rounded-tr-none border border-purple-150 font-normal text-sm xl:text-sm text-left text-purple-150"
	>
		{' '}
		Probing Amazon's Labor Violations{' '}
	</button>
	<button
		data-type="case-question"
		data-id="5895265d-2f8b-4d09-884c-a4c0a800363a"
		className="bg-white p-3 rounded-2xl w-fit rounded-tr-none border border-purple-150 font-normal text-sm xl:text-sm text-left text-purple-150"
	>
		{' '}
		Johnson vs. ABC Insurance{' '}
	</button>
	<button
		data-type="case-question"
		data-id="1acdbd69-d5d5-48da-8df8-30f11009c902"
		className="bg-white p-3 rounded-2xl w-fit rounded-tr-none border border-purple-150 font-normal text-sm xl:text-sm text-left text-purple-150"
	>
		{' '}
		Miller vs. XYZ Corporation{' '}
	</button>
	<button
		data-type="case-question"
		data-id="843b463e-c375-476d-90bd-73f86e30d748"
		className="bg-white p-3 rounded-2xl w-fit rounded-tr-none border border-purple-150 font-normal text-sm xl:text-sm text-left text-purple-150"
	>
		{' '}
		Investigating Mike's Shady Business{' '}
	</button>
	<button
		data-type="case-question"
		data-id="8e0153d8-9396-497f-ac4a-a95d1c65c6be"
		className="bg-white p-3 rounded-2xl w-fit rounded-tr-none border border-purple-150 font-normal text-sm xl:text-sm text-left text-purple-150"
	>
		{' '}
		Shady Grove Fertility Medical Data Breach{' '}
	</button>
	<button
		data-type="case-question"
		data-id="ecee5ec2-eb07-428f-9d0d-d2d919f52ddc"
		className="bg-white p-3 rounded-2xl w-fit rounded-tr-none border border-purple-150 font-normal text-sm xl:text-sm text-left text-purple-150"
	>
		{' '}
		Unmasking Apple's Hidden Trade Practices{' '}
	</button>
	<button
		data-type="case-question"
		data-id="general-questions"
		className="bg-white p-3 rounded-2xl w-fit rounded-tr-none border border-purple-150 font-normal text-sm xl:text-sm text-left text-purple-150"
	>
		{' '}
		General Questions{' '}
	</button>
</div>
</>
 ---------------   Questions  -------------- 

<>
<span className="p-3 rounded-2xl w-fit rounded-tl-none bg-green-20">
	<p className="text-black font-normal text-sm xl:text-sm">
		What type of question are you asking regarding this case?{' '}
	</p>
</span>

<div className="grid grid-cols-2 gap-3">
	<button
		data-type="subject-question"
		data-id="9e73b478-d9c3-4710-aec1-af0bf2484828"
		className="p-3 rounded-2xl w-full rounded-tr-none border border-purple-150 font-normal text-sm xl:text-sm text-left text-purple-150"
	>
		{' '}
		Claim Submission{' '}
	</button>
	<button
		data-type="subject-question"
		data-id="368cb0de-ff5e-404d-bfb3-602d60fd827b"
		className="p-3 rounded-2xl w-full rounded-tr-none border border-purple-150 font-normal text-sm xl:text-sm text-left text-purple-150"
	>
		{' '}
		Documents Required{' '}
	</button>
	<button
		data-type="subject-question"
		data-id="3d6b611d-9637-4ccc-8e20-6ee0902613bb"
		className="p-3 rounded-2xl w-full rounded-tr-none border border-purple-150 font-normal text-sm xl:text-sm text-left text-purple-150"
	>
		{' '}
		Retainer{' '}
	</button>
	<button
		data-type="subject-question"
		data-id="e901720a-d8c4-4f67-b541-6a29b222f95c"
		className="p-3 rounded-2xl w-full rounded-tr-none border border-purple-150 font-normal text-sm xl:text-sm text-left text-purple-150"
	>
		{' '}
		Complaint{' '}
	</button>
	<button
		data-type="subject-question"
		data-id="c030fff4-c476-4c9c-b6dc-8bc1fa59f868"
		className="p-3 rounded-2xl w-full rounded-tr-none border border-purple-150 font-normal text-sm xl:text-sm text-left text-purple-150"
	>
		{' '}
		Case Status{' '}
	</button>
	<button
		data-type="subject-question"
		data-id="4f024a7f-9b51-45dd-94a3-d3ce362f0ef6"
		className="p-3 rounded-2xl w-full rounded-tr-none border border-purple-150 font-normal text-sm xl:text-sm text-left text-purple-150"
	>
		{' '}
		Payment{' '}
	</button>
	<button
		data-type="subject-question"
		data-id="ca6d9af9-e5c5-4a72-96a7-03c77372881e"
		className="p-3 rounded-2xl w-full rounded-tr-none border border-purple-150 font-normal text-sm xl:text-sm text-left text-purple-150"
	>
		{' '}
		General Question{' '}
	</button>
</div>
</>

 --------- End conversation ------------- 

<div className="flex flex-col gap-3">
<span className="p-3 rounded-2xl w-fit rounded-tl-none bg-green-20">
	<p className="text-black font-normal text-sm xl:text-sm">
		Arbitration is a dispute resolution forum where two parties resolve
		disputes without formal court proceedings. It's faster and more
		cost-effective than traditional litigation, overseen by neutral
		third parties.
	</p>
</span>
<span className="p-3 rounded-2xl w-fit rounded-tl-none bg-green-20">
	<p className="text-black font-normal text-sm xl:text-sm">
		Is there anything else I can help you with?
	</p>
</span>
</div>

 ----------------  End conversation 2   --------------------------- 
<div className="flex flex-col gap-3">
<span className="p-3 rounded-2xl w-fit rounded-tl-none bg-green-20">
	<p className="text-black font-normal text-sm xl:text-sm">
		I don't have the information you're looking for. It's best to
		contact your lawyer directly.
		<br />
		<br />
		You can send them a{' '}
		<Link href="/dashboard/inbox" className="text-blue-link">
			message
		</Link>{' '}
		through your Inbox.
	</p>
</span>
</div> */
}
